import React, { useCallback } from 'react';
import classnames from 'classnames';
import Cleave from 'cleave.js/react';

export function CleaveInput({
    name,
    value,
    label,
    onChange,
    onBlur,
    error,
    className = 'uk-margin',
    type = 'text',
    placeholder,
    icon,
    isFlippedIcon,
    options,
    ...rest
}) {
    const innerOnChange = useCallback(
        ({ target: { name, value, rawValue } }) =>
            onChange({
                name,
                value,
                rawValue,
            }),
        [onChange]
    );

    return (
        <div className={className}>
            {label && <label className="uk-form-label">{label}</label>}
            <div className="uk-inline uk-width-1-1">
                {icon && <span className={classnames('uk-form-icon', { 'uk-form-icon-flip': isFlippedIcon })}>{icon}</span>}
                <Cleave
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={innerOnChange}
                    onBlur={onBlur}
                    className="uk-input uk-form-controls"
                    options={options}
                    {...rest}
                />
            </div>
            {error && <div className="uk-text-danger">{error}</div>}
        </div>
    );
}
